import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FieldsInterventionsNavigationComponent } from './fields-interventions-navigation.component';
import {DxDropDownButtonModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionsNavigationComponent],
  imports: [
    CommonModule,
    DxDropDownButtonModule
  ],
  exports: [FieldsInterventionsNavigationComponent]
})
export class FieldsInterventionsNavigationModule { }
